var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnderline10(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 247 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.525 6.282a1408.212 1408.212 0 0147.44-2.728 1441.851 1441.851 0 0147.796-1.146 1456.96 1456.96 0 0147.865.43c15.975.405 31.938 1.079 47.876 2.017a1378.523 1378.523 0 0152.904 4.138c.839.083 1.615-.607 1.594-1.182-.117-3.125-6.825-3.397-9.581-2.349-1.827.694-.218 2.735 1.609 2.041.898-.342 2.05-.31 3.017-.165.467.07.956.165 1.375.343.122.051.266.165.393.2.149.04.006.06 0-.07l1.593-1.182a1382.915 1382.915 0 00-47.036-3.78A1428.142 1428.142 0 00150.781.642a1456.134 1456.134 0 00-47.854-.635C86.899.06 70.877.374 54.866.961c-15.858.58-31.694 1.419-47.499 2.534-1.949.138-3.893.28-5.842.422-2.023.154-2.044 2.518 0 2.365z",
    fill: "#121318"
  })));
}

export default SvgUnderline10;